import React, { useEffect, useState } from 'react';
import TaxRates from './taxRates';
import GSTSettings from './gstSettings';
import { toast } from 'react-toastify';
import { getGSTSetting, updateGstSetting } from '../../../../../services/settings/organization';
import { validateGSTNumber } from '../../../../../utils/utility';
import { getDate } from '../../../../../utils/dateUtils';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useSearchParams } from 'react-router-dom';

export default function TaxSection({ activeTab }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [taxTab, setTaxTab] = useState('Tax Rates');
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isGstRegEnable, setIsGstRegEnable] = useState(false);
	const [error, setError] = useState({});
	const [gstCheckForm, setGSTCheckForm] = useState({});
	const [gstForm, setGSTForm] = useState({
		gstin: '',
		business_legal_name: '',
		business_trade_name: '',
		gst_registration_date: '',
		composition_enable: false,
		composition_scheme: false,
	});

	const handleFormData = (key, value, required = false) => {
		setGSTForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (key === 'gstin') {
				if (value === '' || value === null || value === undefined) {
					newError.gstin = 'Please enter gstin number in the field';
				} else if (!validateGSTNumber(value)) {
					newError.gstin = 'Please enter valid gstin number in the field';
				} else {
					delete newError.gstin;
				}
			}
			if (key === 'business_legal_name') {
				if (value === '' || value === null || value === undefined) {
					newError.business_legal_name = 'Please enter business legal name in the field';
				} else {
					delete newError.business_legal_name;
				}
			}
			if (key === 'business_trade_name') {
				if (value === '' || value === null || value === undefined) {
					newError.business_trade_name = 'Please enter business trade name in the field';
				} else {
					delete newError.business_trade_name;
				}
			}
			if (key === 'gst_registration_date') {
				if (value === '' || value === null || value === undefined) {
					newError.gst_registration_date = 'Please enter gst registration date in the field';
				} else {
					delete newError.gst_registration_date;
				}
			}
			setError(newError);
		}
	};

	function checkValidation() {
		const newError = { ...error };
		if (!gstForm.gstin || gstForm.gstin === '' || gstForm.gstin === undefined) {
			newError.gstin = 'Please senter gstin number in the field';
		} else if (!validateGSTNumber(gstForm.gstin)) {
			newError.gstin = 'Please enter valid gstin number in the field';
		} else {
			delete newError.gstin;
		}
		if (
			!gstForm.business_legal_name ||
			gstForm.business_legal_name === '' ||
			gstForm.business_legal_name === undefined
		) {
			newError.business_legal_name = 'Please enter business legal name in the field';
		} else {
			delete newError.business_legal_name;
		}

		if (
			!gstForm.business_trade_name ||
			gstForm.business_trade_name === '' ||
			gstForm.business_trade_name === undefined
		) {
			newError.business_trade_name = 'Please enter business trade name in the field';
		} else {
			delete newError.business_trade_name;
		}

		if (
			!gstForm.gst_registration_date ||
			gstForm.gst_registration_date === '' ||
			gstForm.gst_registration_date === undefined
		) {
			newError.gst_registration_date = 'Please enter gst registration date in the field';
		} else {
			delete newError.gst_registration_date;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleUpdateGSTSetting = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Creating gst setting failed! Please fill required fields.');
		} else {
			try {
				setLoader(true);
				setIsEdit(false);
				var body = {
					...gstForm,
					gst_registration_enable: true,
				};

				const res = await updateGstSetting(body);
				if (res.success === true) {
					toast.success(res.message);
					getGSTDetail();
				} else {
					setIsEdit(true);
					toast.error(res.message || 'Something went wrong');
				}
			} catch (error) {
				setIsEdit(true);
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const getGSTDetail = async () => {
		try {
			const gstDetail = await getGSTSetting();
			const data = {
				gstin: gstDetail.gstin || '',
				business_legal_name: gstDetail.business_legal_name || '',
				business_trade_name: gstDetail.business_trade_name || '',
				gst_registration_date: getDate(gstDetail.gst_registration_date, true),
				composition_enable: gstDetail.composition_enable,
				composition_scheme: gstDetail.composition_scheme,
			};
			setGSTForm(data);
			setGSTCheckForm(data);
			setIsGstRegEnable(gstDetail.gst_registration_enable);
			setError({});
		} catch (error) {
			toast.error(error.message);
		}
	};

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(gstCheckForm) !== JSON.stringify(gstForm);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (gstForm) {
			getShowUndoChanged();
		}
	}, [gstForm]);

	const setUrlSearchParams = () => {
		if (taxTab === 'GST Settings') {
			const url = new URLSearchParams();
			// Normal params
			url.set('type', 'gst-setting');
			setSearchParams(url);
		}
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [taxTab]);

	const setFilterFromUrl = () => {
		if (searchParams.get('type') === 'gst-setting') {
			setTaxTab('GST Settings');
		} else {
			setTaxTab('Tax Rates');
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	useEffect(() => {
		if (taxTab === 'GST Settings') {
			getGSTDetail();
		}
	}, [taxTab]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={
					taxTab === 'Tax Rates'
						? [
								{
									id: 1,
									button: 'Add New Tax Rates',
									add: true,
									close: false,
									disabled: false,
									handler: () => {
										setIsOpenModal(true);
									},
									className: 'btn-primary',
								},
							]
						: [
								{
									id: 1,
									disabled: !isEdit || loader,
									className: 'btn-primary',
									add: false,
									close: false,
									button: 'Save',
									loader: loader,
									handler: () => {
										handleUpdateGSTSetting();
									},
								},
								isEdit && {
									id: 1,
									disabled: false,
									className: 'btn-primary',
									add: false,
									close: false,
									button: 'Undo Changed',
									handler: () => {
										setIsEdit(false);
										getGSTDetail();
									},
								},
							].filter((button) => button !== false)
				}
			/>
			<div
				className="py-2"
				style={{
					backgroundColor: '#DADDEC',
					position: 'sticky',
					top: '52px',
					zIndex: 100,
					overflow: 'hidden',
				}}
			>
				<ul className="nav mt-2">
					{['Tax Rates', 'GST Settings'].map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<div
								className={`tab-link ${taxTab === item ? 'active' : ''} d-flex align-items-center`}
								onClick={() => {
									setTaxTab(item);
								}}
							>
								{item}
							</div>
						</li>
					))}
				</ul>
			</div>
			{taxTab === 'Tax Rates' ? (
				<TaxRates
					isOpenModal={isOpenModal}
					setIsOpenModal={setIsOpenModal}
					searchParams={searchParams}
					setSearchParams={setSearchParams}
				/>
			) : (
				<GSTSettings
					setIsGstRegEnable={setIsGstRegEnable}
					isGstRegEnable={isGstRegEnable}
					error={error}
					setError={setError}
					gstForm={gstForm}
					setIsEdit={setIsEdit}
					setGSTForm={setGSTForm}
					handleFormData={handleFormData}
				/>
			)}
		</div>
	);
}
